import { __assign, __awaiter, __generator } from "tslib";
import api from './helpers/api';
import { v1 as paginate } from './helpers/pagination';
export default (function (endpoint, params, normalize, options) {
    if (normalize === void 0) { normalize = function (data) { return data; }; }
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/" + endpoint + ".json", __assign({ params: params }, options))];
                case 1:
                    resp = _a.sent();
                    if (resp.data.STATUS === "OK") {
                        return [2 /*return*/, __assign(__assign({}, normalize(resp)), { pagination: paginate(resp) })];
                    }
                    return [2 /*return*/];
            }
        });
    });
});
